import { Button } from '@chakra-ui/react';

export const CreateOfferScorecardButton = ({
  onClick,
  loading,
}: {
  onClick: () => void;
  loading?: boolean;
}) => {
  return (
    <Button
      isLoading={loading}
      size="sm"
      variant={{
        base: 'solid',
        md: 'outline',
      }}
      width={{ base: '50%', md: 'auto' }}
      onClick={onClick}
    >
      Create Offer Scorecard
    </Button>
  );
};
